const WORKSPACE_PAGE_RESOURCE = 'WorkspacePage';

export { WORKSPACE_PAGE_RESOURCE };